import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import FluidImg from 'Components/Utility/FluidImg';
import useViewport from 'Hooks/useViewport';

import 'Components/Banner/RazerCortexCommunityBanner/RazerCortexCommunityBanner.scss';

const RazerCortextCommunityBanner = ({
  needsContainer,
  tag: Tag,
  url,
  externalLink,
}) => {
  const { isAboveSm } = useViewport();

  const formattedUrl = url && !externalLink ? url.split('en/')[1] : url;
  const mobileImg = 'Razer-Cortex-Giveaway-FANATICAL-BANNER-MOBILE.jpg';
  const desktopImg = 'Razer-Cortex-Giveaway-FANATICAL-BANNER.jpg';

  return (
    <section className={classNames({ container: needsContainer })}>
      <Tag href={formattedUrl} to={formattedUrl}>
        <div className="RazerCortextCommunityBanner">
          <div className="RazerCortextCommunityBanner__contentContainer">
            <div className="RazerCortextCommunityBanner__background">
              <FluidImg
                src={isAboveSm ? desktopImg : mobileImg}
                overrideWidth="100"
                folder="assets/partners/Razer"
                alt="Welcome to our Razer Cortex Community Banner"
              />
            </div>
          </div>
        </div>
      </Tag>
    </section>
  );
};

RazerCortextCommunityBanner.propTypes = {
  needsContainer: PropTypes.bool,
  tag: PropTypes.string,
  url: PropTypes.string,
  externalLink: PropTypes.bool,
};

RazerCortextCommunityBanner.defaultProps = {
  needsContainer: false,
  tag: 'div',
  url: '',
  externalLink: false,
};

export default RazerCortextCommunityBanner;
